import React from 'react';
import { Image } from 'antd';

type Iprops = {
  value: any;
  imageWidth?: number;
  imageHeight?: number;
  emptyText?: string,
}

const SPImagesPreview:React.FC<Iprops> = (props) => {
  const { value, imageWidth, imageHeight, emptyText } = props;
  return (
    <>
      {(value || []).length
        ? <Image.PreviewGroup>
            {(value || []).map((item: any) =>(
              <>
                <Image style={{ marginRight: 12 }} width={imageWidth || 100} height={imageHeight || 100} src={ typeof item === 'string' ? item : (item.file_url || item.url)  } />
                <span style={{ display: 'inline-block', width: '6px' }}></span>
              </>
            ))}
          </Image.PreviewGroup>
        : (emptyText || '暂无图片')
      }
    </>
  )
}

export default React.memo(SPImagesPreview);